if (!customElements.get('recently-viewed-products')) {
    customElements.define(
      'recently-viewed-products',
      class ProductRecentlyViewed extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
          this.createObserver({
            element: this,
            callback: this.init.bind(this),
            threshold: 400
          });
        }

         createObserver(options) {
          const threshold = options.threshold ? options.threshold : 0;
          const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                if (typeof options.callback === 'function') {
                  options.callback();
                  observer.unobserve(entry.target);
                }
              }
            });
          }, { rootMargin: `0px 0px ${threshold}px 0px` });
          observer.observe(options.element);
        }

        getCookie(cname) {
          const name = cname + '=';
          const ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
              return c.substring(name.length, c.length);
            }
          }

          return '';
        }
  
        readCookie (name) {
          let list = [],
          data = this.getCookie(name);
          if (data !== null && data !== undefined && data !== '') list = data.split(' ');
          return list
        }
  
        getQueryString(list) {
          if (this.dataset.productId && list.includes(parseInt(this.dataset.productId))) list.splice(list.indexOf(parseInt(this.dataset.productId)), 1);
          return list.map((item) => "id:" + item).slice(0, 10).join(" OR ");
        }
  
        init() {
          this.list = this.readCookie('shopify_recently_viewed_products');
          if(this.list.length === 0) {
            this.checkContent();
            return
          }
          this.loadContent();
        }
  
        checkContent(html = null){
          this.setAttribute('loaded', true);
          this.products = html ? Array.from(html.querySelectorAll('[data-product-item]')) : [];
          if(this.products.length === 0) {
            this.remove();
          }
        }
  
        loadContent() {
          if (!this.getAttribute('loaded')) {
            fetch(this.dataset.url + this.getQueryString(this.list))
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const products = html.querySelector('recently-viewed-products');
                if (products && products.innerHTML.trim().length) this.innerHTML = products.innerHTML;
                this.checkContent(html);
              })
              .catch((e) => {
                console.error(e);
              });
          }
        }
      }
    );
  }